import { computed } from 'vue';
import { IFilterProvider } from './interfaces/filter-providers/IFilterProvider';
import { FilterOptionInformation } from './models/FilterOptionInformation';
import { FilterKey, filterKeysOfLocation } from './models/FilterKey';
import { EventAggregationService } from './platform/EventAggregationService';
import { FilterBase } from './FilterBase.class';
import { Action, Product, Tracker } from '@studyportals/datalake-event-tracker';
import { IExperimentTrackingData } from '@studyportals/datalake-event-tracker/dist/src/interfaces/tracking-data.interface';

export default abstract class Filter extends FilterBase {
	private trackerForExperiment = new Tracker(Product.SEARCH_PAGE, false, true);

	public filterOptions: readonly FilterOptionInformation[];
	public filterProvider: IFilterProvider;

	public collapsed = computed((): boolean => {
		return this.filterProvider.isFilterCollapsed(this.key);
	});

	public filterHintCount = computed((): number => {
		return this.filterProvider.getFilterSelection(this.key).length;
	});

	public constructor(key: FilterKey, filterProvider: IFilterProvider, eventAggregationService: EventAggregationService | undefined) {
		super(key, eventAggregationService);

		this.filterProvider = filterProvider;
		this.filterOptions = this.filterProvider.getFilterOptionInformation(this.key);
	}

	public toggleFilter(): void {
		this.filterProvider.toggleFilterExpandability(this.key);
		this.trackToggleForExperiment();
	}

	private trackToggleForExperiment(): void {
		if (!filterKeysOfLocation.includes(this.key)) return;

		const trackingData: IExperimentTrackingData = {
			category: Product.EXPERIMENT,
			action: this.filterProvider.isFilterCollapsed(this.key) ? Action.CLOSE : Action.OPEN,
			label: 'location-filter',
		};

		try {
			this.trackerForExperiment.trackExperimentEvent(trackingData);
		} catch {
			console.warn(`Error tracking event with tracking data '${JSON.stringify(trackingData)}'`);
		}
	}
}
